import { pick } from 'lodash';
import type { BaseTestInstance } from './types';

export const prepareTestInstance = (
  testInstance: RecursivePartial<BaseTestInstance>,
  customerId?: number
): MutationBody => ({
  data: {
    type: 'TestInstance',
    attributes: {
      ...pick(testInstance, ['name', 'startDate', 'endDate', 'enabled'])
    },
    ...(customerId || testInstance.test
      ? {
          relationships: {
            ...(customerId
              ? { customer: { data: { id: `/api/v2/customers/${customerId}`, type: 'Customer' } } }
              : {}),
            ...(testInstance.test
              ? { test: { data: { id: `/api/v2/tests/${testInstance.test.id}`, type: 'Test' } } }
              : {})
          }
        }
      : {})
  }
});
